export default __webpack_public_path__ + "static/media/white-icon.8617029c.svg";